import NewFacilityForDurationRental, {BusinessSchedule, MaxReservationTimeSetting} from './NewFacilityForDurationRental'
import {
    OptionSettingForNewFacility,
    ReservationSettingsForNewFacility,
    ServerImageInformation,
} from './NewFacilityCommon'
import {Nullable} from '../../app/TypeHelpers'

export default class UpdateFacilityForDurationRental extends NewFacilityForDurationRental {
    version: number

    constructor(
        sortOrder: number,
        categoryId: string | null,
        equipmentIds: number[],
        facilityName: string,
        accessControlManager: string | null,
        cardKeyFacilityNumber: string | null,
        gateNumbers: string[] | null,
        images: ServerImageInformation[],
        facilityIntroductory: string,
        optionSettings: OptionSettingForNewFacility[],
        reservationSetting: ReservationSettingsForNewFacility,
        releaseSetting: string,
        releaseStartDate: Nullable<string>,
        releaseStartTime: Nullable<string>,
        reserveBeforeCleaningTime: number,
        reserveAfterCleaningTime: number,
        businessSchedules: BusinessSchedule[],
        maxReservationTimeSetting: MaxReservationTimeSetting,
        version: number,
    ) {
        super(
            sortOrder,
            categoryId,
            equipmentIds,
            facilityName,
            accessControlManager,
            cardKeyFacilityNumber,
            gateNumbers,
            images,
            facilityIntroductory,
            optionSettings,
            reservationSetting,
            releaseSetting,
            releaseStartDate,
            releaseStartTime,
            reserveBeforeCleaningTime,
            reserveAfterCleaningTime,
            businessSchedules,
            maxReservationTimeSetting,
        )
        this.version = version
    }
}
